import { Component, OnInit } from '@angular/core';
import { RolloutFuncionarioService } from '../../services/rollout-funcionario.service';

import { MigracaoFuncionariosUtil } from '../../utils/migracao-funcionarios-util';

@Component({
  selector: 'app-acompanhar-migracoes',
  templateUrl: './acompanhar-migracoes.component.html',
  styleUrls: ['./acompanhar-migracoes.component.scss']
})
export class AcompanharMigracoesComponent implements OnInit {

  // Expose Util to template
  readonly MigracaoUtil = MigracaoFuncionariosUtil;

  rows = [];
  loadingIndicator = true;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
  };
  searchId = '';

  constructor(private employeeService: RolloutFuncionarioService) { }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  setPage(pageInfo) {
    this.loadingIndicator = true;
    this.page.offset = pageInfo.offset;

    this.employeeService.findBatchPaginatedByFilter(
      this.searchId,
      null,
      null,
      null,
      null,
      this.page.offset,
      this.page.limit,
      (data: any) => {
        this.rows = data.rows || data.items || data.content; // Fallback to legacy properties if needed
        this.page.count = data.totalElements || data.totalCount;
        this.loadingIndicator = false;
      },
      (error) => {
        console.error('Error', error);
        this.loadingIndicator = false;
      }
    );
  }

  onSearch(id: string) {
    this.searchId = id;
    this.setPage({ offset: 0 });
  }
}
